namespace TR {
    export class PricingService {
        private domain = TRPCONFIG.Domain;
        private apiUrl = 'api/hotels/pricing';

        constructor (
            private $http: ng.IHttpService,
            private cookieService) {
        }

        hasActiveVouchers() {
            return this.$http.get(`${this.apiUrl}/hasActiveVouchers`,
            {
                params: { domainId: this.domain.DomainId }
            }
            ).then(response => response.data);
        }
    }

    angular.module('TR').service('pricingService', PricingService);
}
